<template>
    <div ref="container" :class="['bandeja60-container', (vertical ? 'bandeja60-vertical' : 'bandeja60-horizontal')]">
        <div :class="['bandeja60-barra', (soporte1 ? 'bandeja60-soporte-1-yes' : 'bandeja60-soporte-1-no'), (soporte2 ? 'bandeja60-soporte-2-yes' : 'bandeja60-soporte-2-no')]"
            :style="lengthStyle">
            <!-- SOPORTE 1 -->
            <div :class="['bandeja60-soporte', 'bandeja60-soporte-1']">
                <img :src="require('@/assets/images/gamas/60/soporte.png')" />
            </div>
            <!-- BARRA -->
            <div v-if="pared == false" class="bandeja60-barra-interior">
                <img :src="require('@/assets/images/gamas/60/barra.png')" />
            </div>
            <!-- PARED -->
            <div v-if="pared" class="bandeja60-barra-interior">
                <img :src="require('@/assets/images/gamas/60/pared.png')" />
            </div>
            <!-- SOPORTE 2 -->
            <div :class="['bandeja60-soporte', 'bandeja60-soporte-2']">
                <img :src="require('@/assets/images/gamas/60/soporte.png')" />
            </div>
        </div>
    </div>
</template>
<script>
import { Fragment } from 'vue-fragment'
import { app } from "../../../application.js";

export default {
    name: "barraComponent",
    props: {
        pared:{
            type: Boolean,
            default: false
        },
        soporte1: true,
        soporte2: true,
        vertical: {
            type: Boolean,
            default: true
        },
        length100percent: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: 100
        },
    },
    data() {
        return {
            app: app,
        }
    },
    components: {
        Fragment
    },
    computed: {
        isMobile() {
            return this.app.isMobile;
        },
        lengthStyle() {
            if (this.length100percent) {
                return {
                    width: '100%'
                }
            }
            return {
                width: this.length + 'px'
            }
        }
    },
    mounted() {
    }
}
</script>
<style lang="scss">
.bandeja60-container {
    width: 100%;
    height: 65px;

    &.bandeja60-vertical {
        .bandeja60-barra{
            transform: rotate(90deg);
            transform-origin: left top;
        }
    }

}

.bandeja60-barra {

    position: relative;
    height: 65px;

    padding: 0 !important;
    margin: 0 !important;

    img {
        padding: 0 !important;
        margin: 0 !important;
    }
}

.bandeja60-soporte {
    position: absolute;
    height: 65px;

    img {
        width: 25px;
        height: 65px;
    }

    &.bandeja60-soporte-1 {
        left: 0;

        .bandeja60-soporte-1-no & {
            display: none;
        }
    }

    &.bandeja60-soporte-2 {
        right: 0;

        transform: rotate(180deg);
        .bandeja60-soporte-2-no & {
            display: none;
        }
    }
}

.bandeja60-barra-interior {
    position: absolute;
    top: 18px;
    bottom: 0;
    left: 0;
    right: 0;
    padding-left: 24px;

    .bandeja60-soporte-1-no & {
        padding-left: 0;
    }

    padding-right: 24px;

    .bandeja60-soporte-2-no & {
        padding-right: 0;
    }

    width: 100%;

    img {
        height: 26px;
        width: 100%;
    }
}
</style>